export * from './instituionWebAnalytics.actions'
export * from './downloadsWebAnalytics.actions'
export * from './tradingAnalytics.action'

export const FETCHING = 'FETCHING'
export const IDLE = 'IDLE'
export const FETCHED = 'FETCHED'
export const FAILED = 'FAILED'
